import { inViewPortVertical } from './helpers';

(function wordsFadeInAnimation() {
    const jsAnimatedTexts = document.querySelectorAll('.js-animated-text');
    if (!jsAnimatedTexts) {
        return;
    }
    let prepCompleted = false;
    const animatedTexts = [];
    const fadeInWords = (element) => {
        element.querySelectorAll('.animate__animated').forEach((word, index) => {
            setTimeout(() => {
                word.classList.add('animate__fadeIn');
            }, index * 40);
        });
    }
    const prepWordsFadeIn = (element) => {
        const words = element.textContent.split(' ');
        element.innerHTML = words
            .map(word => `<span class="animate__animated">${word}</span>`)
            .join(' ');
    }
    document.addEventListener('scroll', () => {
        if (!prepCompleted) return;
        for (const text of jsAnimatedTexts) {
            if (inViewPortVertical(text) && !animatedTexts.includes(text)) {
                fadeInWords(text);
                animatedTexts.push(text);
            }
        }
    });
    document.addEventListener('DOMContentLoaded', () => {
        for (const text of jsAnimatedTexts) {
            prepWordsFadeIn(text);
            if (inViewPortVertical(text) && !animatedTexts.includes(text)) {
                fadeInWords(text);
                animatedTexts.push(text);
            }
        }
        prepCompleted = true;
    });
})();

(function imageScaleAnimation() {
    const jsAnimatedImages = document.querySelectorAll('.js-animated-image');
    if (!jsAnimatedImages) {
        return;
    }
    let prepCompleted = false;
    document.addEventListener('scroll', () => {
        if (!prepCompleted) return;
        for (const image of jsAnimatedImages) {
            if (image.classList && image.classList.contains('animate__scale')) {
                continue;
            }
            if (!inViewPortVertical(image, true)) {
                continue;
            }
            image.classList.add('animate__scale');
        }
    });
    document.addEventListener('DOMContentLoaded', () => {
        for (const image of jsAnimatedImages) {
            image.classList.add('animate__animated');
            if (inViewPortVertical(image, true)) {
                image.classList.add('animate__scale');
            }
        }
        prepCompleted = true;
    });
})();

(function cardsFloatInAnimation() {
    const jsAnimatedCards = document.querySelectorAll('.js-animated-cards');
    if (!jsAnimatedCards) {
        return;
    }
    const floatInCards = (element) => {
        for (const card of element.querySelectorAll('.animate__animated')) {
            if (card.classList && card.classList.contains('animate__floatIn')) {
                continue;
            }
            if (!inViewPortVertical(card, true)) {
                continue;
            }
            setTimeout(() => {
                card.classList.add('animate__floatIn');
            }, 40);
        }
    }
    document.addEventListener('scroll', () => {
        for (const cardWrapper of jsAnimatedCards) {
            floatInCards(cardWrapper);
        }
    });
    document.addEventListener('DOMContentLoaded', () => {
        for (const cardWrapper of jsAnimatedCards) {
            floatInCards(cardWrapper);
        }
    });
})();

(function paragraphsSlideInAnimation() {
    const paragraphs = document.querySelectorAll('.js-animated-content > p, .js-animated-content > ul');
    if (!paragraphs) {
        return;
    }
    const floatInParagraphs = () => {
        for (const p of paragraphs) {
            if (p.classList.contains('animate__slideIn')) {
                continue;
            }
            const { scrollY, innerHeight } = window;
            const { offsetTop, offsetHeight } = p;
            const middle = offsetTop + (0.5 * offsetHeight);
            const bottom = scrollY + innerHeight;
            if (middle < bottom) {
                p.classList.add('animate__slideIn');
            }
        }
    }
    document.addEventListener('scroll', floatInParagraphs);
    document.addEventListener('DOMContentLoaded', floatInParagraphs);
})();

(function headlineFadeInAnimation() {
    const headlines = document.querySelectorAll('.js-animated-content > .wp-block-heading, .js-animated-content > *:is(h1, h2, h3, h4, h5, h6), .page-header h1, .section *:is(h1, h2, h3, h4, h5, h6), .single-service h3');
    if (!headlines) {
        return;
    }
    const originalHeadlines = [];
    const fadeInHeadlines = () => {
        for (const headline of headlines) {
            if (headline.classList && headline.classList.contains('animate__animated')) {
                continue;
            }
            if (!inViewPortVertical(headline, true)) {
                continue
            }
            let timer = null;
            let i = 0;
            const words = headline.textContent.split(' ');
            headline.classList.add('animate__animated');
            originalHeadlines.push(headline.textContent);
            headline.textContent = '';
            for (let word of words) {
                const chars = word.split('');
                let charHtml = '';
                for (let char of chars) {
                    charHtml += `<span class="headline__letter">${char}</span>`
                }
                headline.innerHTML += `<span class="headline__word">${charHtml}</span>`;
            }
            const chars = headline.textContent.split('');
            const onTick = () => {
                const span = headline.querySelectorAll('span.headline__word span.headline__letter')[i];
                span.classList.add('animate__headline');
                i++;
                if (i === chars.length) {
                    clearInterval(timer);
                    timer = null;
                    setTimeout(() => {
                        revertToOriginalText(headline);
                    }, 500);
                }
            }
            timer = setInterval(onTick, 20);
        }
    }
    const revertToOriginalText = (headline) => {
        for (const original of originalHeadlines) {
            if (headline.textContent === original.replace(/ /g,"")) {
                headline.textContent = original;
            }
        }
    }
    document.addEventListener('scroll', fadeInHeadlines);
    document.addEventListener('DOMContentLoaded', fadeInHeadlines);
})();